const DashboardLayout = () => import("@/pages/Layout/DashboardLayout.vue");

const Maps = () => import("@/pages/Maps.vue");
const AlarmList = () => import("@/pages/AlarmList.vue");
const CockPit = () => import("@/pages/CockPit.vue");
const HistoryList = () => import("@/pages/HistoryList.vue");
const LoginPage = () => import("@/pages/login/LoginPage.vue");
const Reports = () => import("@/pages/Reports.vue");
const ManagementReports = () => import("@/pages/ManagementReports.vue");
const Activities = () => import("@/pages/Activities.vue");
const Equipments = () => import("@/pages/Equipments.vue");
const FTE = () => import("@/pages/FTE.vue");
const NewTicket = () => import("@/pages/NewTicket.vue");
const OpenTicket = () => import("@/pages/OpenTicket.vue");
const Consumables = () => import("@/pages/Consumables.vue");
const ConsumableInfo = () => import("@/pages/ConsumableInfo.vue");
const ConsumableAdd = () => import("@/pages/ConsumableAdd.vue");
const Finance = () => import("@/pages/Finance.vue");
const KnowBase = () => import("@/pages/KnowBase.vue");
const DashboardTag = () => import("@/pages/DashboardTag.vue");
const TrendChart = () => import("@/pages/TrendChart.vue");

import { isUserManager } from "../util/is-user-manager";

export const ROUTES = {
  ACTIVITIES: "ACTIVITIES"
};

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/reports",
    children: [
      {
        path: "finance",
        name: "Finance",
        meta: {
          ignoreZabbix: true
        },
        component: Finance
      },
      {
        path: "fte",
        name: "FTE",
        meta: {
          ignoreZabbix: true
        },
        beforeEnter: (_to, _from, next) => {
          if (!isUserManager()) {
            return next("/");
          }

          next();
        },
        component: FTE
      },
      {
        path: "equipments",
        name: "Equipments",
        meta: {
          ignoreZabbix: true
        },
        component: Equipments
      },
      {
        path: "/online",
        beforeEnter() { location.href = "https://online.acecoti.com.br"; }
      },
      {
        path: "activities",
        name: ROUTES.ACTIVITIES,
        meta: {
          ignoreZabbix: true
        },
        component: Activities
      },
      {
        path: "reports",
        name: "Reports",
        meta: {
          ignoreZabbix: true
        },
        component: Reports
      },
      {
        path: "managementreports",
        name: "Gerencial",
        meta: {
          ignoreZabbix: true
        },
        beforeEnter: (_to, _from, next) => {
          if (!isUserManager()) {
            return next("/");
          }

          next();
        },
        component: ManagementReports
      },
      {
        path: "consumables",
        name: "Consumables",
        meta: {
          ignoreZabbix: true
        },
        component: Consumables
      },
      {
        path: "consumableinfo/:id",
        name: "ConsumableInfo",
        meta: {
          ignoreZabbix: true
        },
        component: ConsumableInfo
      },
      {
        path: "consumableadd",
        name: "ConsumableAdd",
        meta: {
          ignoreZabbix: true
        },
        component: ConsumableAdd
      },
      {
        path: "history",
        name: "HISTÓRICO",
        component: HistoryList
      },
      {
        path: "cockpit",
        name: "COCKPIT",
        component: CockPit
      },
      {
        path: "maps",
        name: "MAPA",
        meta: {
          hideFooter: true
        },
        component: Maps
      },
      {
        path: "alarmlist",
        name: "ALARMES",
        component: AlarmList
      },
      {
        path: "dashboard/:id",
        name: "ONLINE",
        component: DashboardTag
      },
      {
        path: "trendchart/:id",
        name: "GRAFICO",
        component: TrendChart
      },
      {
        path: "openticket/:id",
        name: "Chamado Aberto",
        meta: {
          ignoreZabbix: true
        },
        component: OpenTicket
      },
      {
        path: "newticket",
        name: "Abertura",
        meta: {
          ignoreZabbix: true
        },
        component: NewTicket
      },
      {
        path: "knowbase",
        name: "Documentos",
        meta: {
          ignoreZabbix: true
        },
        component: KnowBase
      },
    ]
  },
  { path: "/login", component: LoginPage },
  // otherwise redirect to home
  { path: "*", redirect: "/" }
];

export default routes;
